module.exports = __webpack_public_path__ + "img/selected.46851559.svg";